var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingAndDiagnosis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37991_113330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66998 1.32812V14.6581L4.00373 13.9916L5.33748 14.6581L6.67123 13.9916L8.00498 14.6581L9.33873 13.9916L10.6725 14.6581L12.0062 13.9916L13.34 14.6581V1.32812L12.0062 1.99462L10.6725 1.32812L9.33873 1.99462L8.00498 1.32812L6.67123 1.99462L5.33748 1.32812L4.00373 1.99462L2.66998 1.32812Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.67 5.32812H6.67253C5.93661 5.32812 5.34003 5.92471 5.34003 6.66062C5.34003 7.39654 5.93661 7.99312 6.67253 7.99312H9.33753C10.0734 7.99312 10.67 8.58971 10.67 9.32562C10.67 10.0615 10.0734 10.6581 9.33753 10.6581H5.34003",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6581V4.32812Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6581V4.32812",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0C66E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37991_113330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAndDiagnosis);
export default __webpack_public_path__ + "static/media/billingAndDiagnosis.3178fdcf5999bc235cb8d17349335e4b.svg";
export { ForwardRef as ReactComponent };